import Typography from '@mui/material/Typography';
import CashFlowData from './PaymentsList';

const InflowPayments =() => {    
    return(
      <>
       <Typography>
          <CashFlowData accountType={'Inflow'} type={'account-receivable'} />
       </Typography>
       </>
    );
};
export default InflowPayments;